import React from 'react';
import Cookie from 'js-cookie';
import { useSelector } from 'react-redux';
import { Container, Row, Col } from '@ott/grid';
import { EmailSubscriptionBanner } from '@ott/email-subscription';

import styles from './EmailSubscriptionSection.scss';

const getKMData = () => {
  const kmData = {} as { bid?: string };

  const bid = Cookie.get('bid') || '';

  if (bid) {
    kmData.bid = bid;
  }

  return kmData;
};

const EmailSubscriptionSection = () => {
  const auth = useSelector((state: { [key: string]: any }) => state.common.auth);
  const KMData = getKMData();

  return (
    <div className={styles.wrapper}>
      <Container>
        <Row>
          <Col desktop={{ offset: 1, span: 10 }} mobile={4}>
            <EmailSubscriptionBanner
              className={styles.container}
              auth={auth}
              metrics={{
                eventName: 'subscribe_from_landing',
                KMData,
              }}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default React.memo(EmailSubscriptionSection);
